import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import Folder from 'owa-mail-store/lib/store/schema/Folder';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

// Same order as in OWA:MailFolderTreeNodeViewModel.cs
const GEEK_FOLDERS_TO_HIDE: DistinguishedFolderIdName[] = ['journal', 'outbox', 'syncissues'];

function isOfTypeMailFolder(folder: Folder): boolean {
    return folder && folder.__type === 'Folder:#Exchange';
}

// Same logic as OWA:MailFolderTreeNodeViewModel.cs:CanAddFolderToFolderCollection()
const isFolderSupported = (folder: Folder): boolean => {
    // VSO 1192: Support public folder.
    // if (folder.isPublicFolder) {
    //     return true;
    // }

    // Do not show the folder if it's not a mail folder.
    if (!isOfTypeMailFolder(folder)) {
        return false;
    }

    // Suppress hidden and 'geek' folders (outbox, journal, etc).
    if (folder.isHidden || GEEK_FOLDERS_TO_HIDE.indexOf(folderIdToName(folder.FolderId.Id)) >= 0) {
        return false;
    }

    // Only show the Notes folder if that feature is enabled.
    const userConfiguration = getUserConfiguration();
    if (folderIdToName(folder.FolderId.Id) === 'notes') {
        return userConfiguration.SegmentationSettings.StickyNotes;
    }

    // Only show the Junk Email folder if that feature is enabled.
    if (
        folderIdToName(folder.FolderId.Id) === 'junkemail' &&
        !userConfiguration.SegmentationSettings.JunkEMail
    ) {
        return false;
    }

    // Good folder!
    return true;
};

export default isFolderSupported;
